import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { useContent } from "@/context/ContentContext";

export default function AdminContent() {
  const { content: c0, refresh } = useContent();
  const [hero, setHero] = useState(c0.hero);
  const [conditionsText, setConditionsText] = useState((c0.conditions || []).join("\n"));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setHero(c0.hero);
    setConditionsText((c0.conditions || []).join("\n"));
  }, [c0]);

  const saveHero = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content/hero", hero);
      toast.success("Hero updated");
      refresh();
    } catch { toast.error("Failed"); }
    finally { setSaving(false); }
  };

  const saveConditions = async () => {
    setSaving(true);
    try {
      const arr = conditionsText.split("\n").map((s) => s.trim()).filter(Boolean);
      await api.put("/admin/content/conditions", arr);
      toast.success("Conditions updated");
      refresh();
    } catch { toast.error("Failed"); }
    finally { setSaving(false); }
  };

  const upd = (k, v) => setHero((h) => ({ ...h, [k]: v }));

  return (
    <div data-testid="admin-content">
      <div className="kbd">— Content</div>
      <h1 className="mt-2 font-serif text-4xl tracking-tightest">Homepage content</h1>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="hairline p-6 bg-white/70">
          <h2 className="font-serif text-2xl tracking-tightest">Hero</h2>
          <div className="mt-6 space-y-4">
            {["overline","line1","line2","line3","sub","cta_primary","cta_secondary"].map((k) => (
              <div key={k}>
                <Label className="kbd">{k}</Label>
                {k === "sub" ? (
                  <Textarea data-testid={`hero-${k}`} value={hero?.[k] || ""} onChange={(e) => upd(k, e.target.value)} className="mt-2"/>
                ) : (
                  <Input data-testid={`hero-${k}`} value={hero?.[k] || ""} onChange={(e) => upd(k, e.target.value)} className="mt-2"/>
                )}
              </div>
            ))}
            <button onClick={saveHero} disabled={saving} data-testid="save-hero" className="btn-pill-inv disabled:opacity-60">
              {saving ? "Saving…" : "Save hero"}
            </button>
          </div>
        </div>

        <div className="hairline p-6 bg-white/70">
          <h2 className="font-serif text-2xl tracking-tightest">Conditions marquee</h2>
          <p className="mt-2 text-sm text-ink-muted">One condition per line.</p>
          <Textarea data-testid="conditions-textarea" rows={20} value={conditionsText} onChange={(e) => setConditionsText(e.target.value)} className="mt-4 font-mono text-sm"/>
          <button onClick={saveConditions} disabled={saving} data-testid="save-conditions" className="btn-pill-inv disabled:opacity-60 mt-4">
            {saving ? "Saving…" : "Save conditions"}
          </button>
        </div>
      </div>
    </div>
  );
}
